import { render, staticRenderFns } from "./GradesMobile.vue?vue&type=template&id=0b07a13a&scoped=true&"
import script from "./GradesMobile.vue?vue&type=script&lang=js&"
export * from "./GradesMobile.vue?vue&type=script&lang=js&"
import style0 from "./GradesMobile.vue?vue&type=style&index=0&id=0b07a13a&prod&lang=scss&scoped=true&"
import style1 from "./GradesMobile.vue?vue&type=style&index=1&id=0b07a13a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07a13a",
  null
  
)

export default component.exports